import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

import { router } from '@/router/router.tsx';

// When the OS hands a Universal Link (iOS) / App Link (Android) to the app — e.g.
// a magic-link email tapped in Mail — Capacitor delivers the full https URL. We
// forward only its path + query into the SPA router so the matching in-app page
// (MagicLinkCallback) runs and exchanges the secret inside the app instead of the
// browser. If the app is NOT installed, the OS opens the URL in the browser and
// the same web page handles it — no native code involved.

// Magic-link secrets are single-use. Cold start can surface the launch URL via
// BOTH getLaunchUrl() and an appUrlOpen event; dedupe so we never consume twice.
let lastHandledUrl: string | null = null;

const routeFromUrl = (rawUrl: string) => {
  if (rawUrl === lastHandledUrl) return;
  lastHandledUrl = rawUrl;
  // OAuth callbacks are consumed by AuthForm's in-flow appUrlOpen listener — routing
  // them here lands on a non-existent SPA path (/google|apple/callback) and flashes 404.
  if (/\/(google|apple)\/callback/.test(rawUrl)) return;
  try {
    const url = new URL(rawUrl);
    void router.navigate(`${url.pathname}${url.search}`);
  } catch (err) {
    console.error('Failed to route deep link:', rawUrl, err);
  }
};

export const initDeepLinks = (): void => {
  if (!Capacitor.isNativePlatform()) return;

  // Warm start: app already running when the link is tapped.
  void CapacitorApp.addListener('appUrlOpen', ({ url }) => routeFromUrl(url));

  // Cold start: app was launched by the link.
  void CapacitorApp.getLaunchUrl().then((res) => {
    if (res?.url) routeFromUrl(res.url);
  });
};
